import { render, staticRenderFns } from "./caixaAbertoMobile.vue?vue&type=template&id=72df5516&scoped=true&"
import script from "./caixaAbertoMobile.vue?vue&type=script&lang=js&"
export * from "./caixaAbertoMobile.vue?vue&type=script&lang=js&"
import style0 from "./caixaAbertoMobile.vue?vue&type=style&index=0&id=72df5516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df5516",
  null
  
)

export default component.exports